<template>
  <div class="slide-image n-caption">
    <div class="flex" />
    <!-- <div class="audio-control-slide" v-if="$store.state.slideActive.id && $store.state.slideActive.audioLink">
      <AudioControl />
    </div> -->
  </div>
</template>

<script>
// import AudioControl from '@/components/presentations/AudioControl'

export default {
  components: {
    // AudioControl,
  },
}
</script>

<style lang="scss" scoped>
// .audio-control-slide {
//   text-align: center !important;

//   &.m-r-t {
//     margin-top: 8px;
//   }
// }
</style>
